import { Box } from '@mui/material'

const PageContainer = ({ children }) => {
  return (
    <Box
      sx={{
        maxWidth: '700px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
        mt: 8,
        pb: 6 // 푸터와 아래 여백 확보
      }}
    >
      {children}
    </Box>
  )
}

export default PageContainer 